import React from 'react';
import { Cell, CellIcon, CellTitle } from './styles';
import { IBCellProps } from './types';

const IBCell: React.FC<IBCellProps> = ({ name, path }) => {
  const handleClick = React.useCallback(() => {
    location.hash = path;
  }, [path]);
  return (
    <Cell onClick={handleClick}>
      <CellIcon src={`icon/${name}.svg`} alt={name} />
      <CellTitle>{name}</CellTitle>
    </Cell>
  );
};

export default IBCell;
